
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class CsVatTypeGrid extends Serenity.EntityGrid<CsVatTypeRow, any> {
        protected getColumnsKey() { return CsVatTypeColumns.columnsKey; }
        protected getDialogType() { return CsVatTypeDialog; }
        protected getIdProperty() { return CsVatTypeRow.idProperty; }
        protected getInsertPermission() { return CsVatTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsVatTypeRow.localTextPrefix; }
        protected getService() { return CsVatTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}